<template>
    <module-card :nextDisabled="nextDisabled">
        <p>{{ communicationStrategy.strategy }}</p>
        <div v-for="response in communicationResponses" :key="response.id" @click.stop="select(response)" class="grey pa-3 mb-1 response" :class="{ 'lighten-3': !isSelected(response) }" v-ripple>
            {{ response.choice }}
        </div>
    </module-card>
</template>

<script>
    export default {
        props: {
            prompt: {
                type: Number,
                required: false
            }
        },
        computed: {
            selectedResponse() {
                if (this.communicationStrategy.response === null) {
                    return null;
                }

                return this.communicationResponses[this.communicationStrategy.response];
            },
            communicationStrategy() {
                return this.$store.get(`peepInLoveCommunicationStrategies@${this.prompt}`);
            },
            communicationResponses() {
                return this.$store.get(`content@peepInLoveCommunicationResponses`);
            }
        },
        methods: {
            nextDisabled() {
                if (this.selectedResponse === null) {
                    return true;
                }

                return false;
            },
            select(response) {
                this.$store.set(`peepInLoveCommunicationStrategies@${this.prompt}.response`, response.id);
            },
            isSelected(response) {
                if (this.selectedResponse === null) {
                    return false;
                }

                return response.id === this.selectedResponse.id;
            }
        }
    };
</script>
